import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { globals } from "../../globals";
import { IGridifyQuery } from "gridify-client";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { TipoSituacaoCadastral } from "../../dominio/enums";
import { PaginatedModel } from "../../dominio/paginated-model";
import { GiFinMotivoNegativaModel } from "../../dominio/gi-fin-motivo-negativa-model";
import { GiFinSimulacaoFinanciadoraModel } from "../../dominio/gi-fin-simulacao-financiadora-model";

export class MotivoNegativaGetOneResponse {
  result: GiFinMotivoNegativaModel;
}

export class MotivoNegativaGetManyResponse {
  results: GiFinMotivoNegativaModel[];
  pagination: PaginatedModel
}

/**
 * Motivos ativos para o select de uma financiadora. Se ela já usa um motivo que foi inativado,
 * ele continua na lista para não sumir da tela.
 */
export function opcoesMotivoNegativa(
  ativos: GiFinMotivoNegativaModel[],
  vinculo: GiFinSimulacaoFinanciadoraModel,
): GiFinMotivoNegativaModel[] {
  if (!vinculo.idMotivoNegativa || ativos.some((m) => m.id === vinculo.idMotivoNegativa)) {
    return ativos;
  }

  return [...ativos, { id: vinculo.idMotivoNegativa, descricao: vinculo.justificativaNegativa }];
}

export class MotivoNegativaRequest {
  descricao: string;
  situacao: TipoSituacaoCadastral;
}

@Injectable({
  providedIn: 'root'
})
export class MotivoNegativaConfigService {
  private readonly url = `${globals.apiUrl}/api/v2/financiamentos/resources/motivos-negativa`;

  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService,
  ) {
  }

  buscarPorId(idMotivo: number): Observable<MotivoNegativaGetOneResponse> {
    return this.http.get<MotivoNegativaGetOneResponse>(`${this.url}/${idMotivo}`);
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<MotivoNegativaGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<MotivoNegativaGetManyResponse>(this.url, { params });
  }

  buscarAtivos(): Observable<MotivoNegativaGetManyResponse> {
    const queryFilter = this.queryFilterService.getQueryBuilder()
      .setPage(1)
      .setPageSize(1000)
      .addCondition("situacao", "=", TipoSituacaoCadastral.Ativo.toString())
      .build();

    return this.buscarTodos(queryFilter);
  }

  cadastrar(data: MotivoNegativaRequest): Observable<MotivoNegativaGetOneResponse> {
    return this.http.post<MotivoNegativaGetOneResponse>(this.url, data);
  }

  atualizar(idMotivo: number, data: MotivoNegativaRequest): Observable<MotivoNegativaGetOneResponse> {
    return this.http.put<MotivoNegativaGetOneResponse>(`${this.url}/${idMotivo}`, data);
  }

  excluir(idMotivo: number): Observable<void> {
    return this.http.delete<void>(`${this.url}/${idMotivo}`);
  }
}
